// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let AccountMemberUtils = require("./AccountMemberUtils.bs.js");
let SubusersPageAccountsListItem = require("./SubusersPageAccountsListItem.bs.js");

function SubuserMemberTableRow(props) {
  return JsxRuntime.jsx(SubusersPageAccountsListItem.make, {
    member: props.member,
    account: props.account,
    render: (name, member, actions, confirmation, editor) => {
      if (editor !== undefined) {
        return JsxRuntime.jsx("tr", {
          children: JsxRuntime.jsxs("td", {
            children: [
              confirmation,
              editor
            ],
            colSpan: 5
          })
        });
      } else {
        return JsxRuntime.jsxs("tr", {
          children: [
            JsxRuntime.jsxs("td", {
              children: [
                confirmation,
                name
              ],
              className: "block py-1 pr-4 font-semibold break-words md:table-cell md:py-4"
            }),
            JsxRuntime.jsx("td", {
              children: Stdlib_Option.getOr(Stdlib_Option.map(member.agent.emailAddress, Scalars.EmailAddress.toString), ""),
              className: "block py-1 pr-4 text-zinc-600 break-words md:table-cell md:py-4"
            }),
            JsxRuntime.jsx("td", {
              children: Stdlib_Option.getOr(Stdlib_Option.map(Stdlib_Option.flatMap(member.role, SubusersPageAccountsListItem.MemberFragment.accountMemberRole_decode), AccountMemberUtils.roleToString), ""),
              className: "block py-1 pr-4 text-zinc-600 md:table-cell md:py-4"
            }),
            JsxRuntime.jsx("td", {
              children: "Registered",
              className: "block py-1 pr-4 text-sm text-zinc-600 md:table-cell md:py-4"
            }),
            JsxRuntime.jsx("td", {
              children: JsxRuntime.jsx("div", {
                children: actions,
                className: "flex md:justify-end"
              }),
              className: "block pt-2 md:table-cell md:py-4"
            })
          ],
          className: "block py-4 md:table-row md:py-0"
        });
      }
    },
    currentUserRole: props.currentUserRole
  });
}

let make = SubuserMemberTableRow;

exports.make = make;
/* Scalars Not a pure module */
